import { render, staticRenderFns } from "./builder-debugger.vue?vue&type=template&id=a39e6ca0&"
import script from "./builder-debugger.vue?vue&type=script&lang=js&"
export * from "./builder-debugger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports